const steps = [
  {
    step: '1',
    title: 'Appel ou diagnostic',
    description: 'Contactez-nous au 09 80 80 22 42. Nous échangeons sur votre panne et planifions une intervention rapide.',
    icon: 'ri-phone-line',
  },
  {
    step: '2',
    title: 'Devis gratuit',
    description: 'Notre technicien se déplace, diagnostique la panne et vous remet un devis clair, sans engagement.',
    icon: 'ri-file-text-line',
  },
  {
    step: '3',
    title: 'Intervention 24-48h',
    description: 'Une fois le devis validé, nous intervenons sous 24 à 48h pour réparer votre menuiserie dans les règles de l\'art.',
    icon: 'ri-tools-line',
  },
  {
    step: '4',
    title: 'Garantie 10 ans',
    description: 'Votre réparation est couverte par notre garantie décennale. Vous profitez d\'une menuiserie comme neuve, en toute sérénité.',
    icon: 'ri-shield-check-line',
  },
];

export default function ProcessSteps() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-3">
            Comment ça se passe ?
          </h2>
          <p className="text-secondary-500 font-body text-base md:text-lg max-w-xl mx-auto">
            Un processus simple et rapide pour la réparation de votre baie coulissante.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div key={s.step} className="relative bg-white rounded-lg p-6 text-center">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-500 text-white font-heading font-bold text-xl mx-auto mb-4">
                {s.step}
              </span>
              <h3 className="font-heading font-semibold text-base text-primary-500 mb-2">
                {s.title}
              </h3>
              <p className="text-secondary-500 text-sm font-body leading-relaxed">
                {s.description}
              </p>
              {i < steps.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-3 w-6 h-6 text-accent-400">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-2xl"></i>
                  </span>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}